<template>
  <div class="wrapper">
    <div class="detail-content1"><p><img src="../../../../static/images/product/domesticTradeCredit/productDetail.png" alt="" width="100%" height="auto"></p></div>
    <div class="space-between functionUnit">
      <div class="submitBtn" @click="submitBtn()">立即申请</div>
    </div>
    <!-- 弹窗 -->
    <div class="customPopover" v-if="notificationPopup">
      <div class="shadow"></div>
      <div class="dialog">
        <div class="dialogBd">
          <div class="warmPrompt">温馨提示</div>
          <div class="dialogTitle">确认进入投保申请~</div>
        </div>
        <div class="dialogContent">
          <p>·尊敬的客户：</p>
          <p>您即将进入投保申请，请仔细阅读投保须知、保险条款等文件。本保险产品由 [<span style="font-weight: bold">现代财产保险(中国)有限公司</span>]
            承保，本产品的销售机构为【正迅保险经纪有限公司】,相关保单服务将由【正迅保险经纪有限公司】 和 [现代财产保险(中国)有限公司] 共同提供。</p>
          <p>·本产品对于部分无法在线完成核保、保全、理赔等保险业务活动的，保险公司可能存在通过本公司分支机构或线下合作机构配合服务。</p>
          <p>
            <span>·投保前请您阅读</span>
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2021/10/e18184f2896e4f1883b892726e445f47.pdf" target="_blank">《客户告知书》</a>
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2021/10/76c2c8b74bb64649a9cbcb0ea8bbc910.pdf" target="_blank">《个人信息保护政策》</a>
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2021/10/22469315218c427db5651c257da6970b.pdf" target="_blank">《服务协议》</a>
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2025/6/1321ecdfbb02459b9955ab8942ed7f51.pdf" target="_blank">《投保须知》</a>
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2025/6/e9f798438832413f9b09a08332c03d3f.pdf" target="_blank">《隐私政策》</a>
<!--            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2025/6/2cded65c057640829f0f4bf7011237a8.pdf" target="_blank">《保险条款》</a>-->
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2026/8/a0c5c0a57afa467ead0c2154c5dc2ed9.pdf" target="_blank">《保险条款》</a>
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2025/6/c0487db0a44f4648a0f8b1a6bdb4fe94.pdf" target="_blank">《责任免除》</a>
            <a href="https://pic.xiaobaibao.com/pdfnew/pdf.html?path=https://pic.xiaobaibao.com/clause/2025/6/4ff99e66103d4b148bf40118566465b6.pdf" target="_blank">《投保单样本》</a>
          </p>
          <br/>
          <p style="color: #ff7052;font-weight: bold;">·点击 “已阅读并同意” ，您在销售页面的操作将被依法记录和保存。</p>
        </div>
        <div class="dialogBtn">
          <a href="javascript:;" class="onOkLabel" @click="onOkLabel">已阅读并同意</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "domesticTradeCredit_productDetail",
    data() {
      return {
        notificationPopup: false,
        insuranceInfoId: "100476",
        planId: "1803",
        sellProductId: "1015082",
        beShareToken: "",
        orderToken: "",                   // 订单Token
      };
    },
    methods: {
      submitBtn() {
        let that = this;

        that.notificationPopup = true;
      },
      // 已阅读并同意
      onOkLabel(){
        let that = this;

        let datas = { orderToken: that.orderToken, beShareToken: that.beShareToken, eventLogToken: that.eventLogToken };
        that.$router.push({path: '/domesticTradeCredit/insureInfo', query: datas});
      },
      // 保险产品库详情
      findInsuranceInfoDetail(){
        let that = this;
        that.$$.request({
          url: that.UrlConfig.insuranceInfo_detail,
          pars: {
            insuranceInfoId: that.insuranceInfoId,
            sellProductInfoId: that.sellProductId,
            shareToken: that.beShareToken,
          },
          loading: true,
          sfn: function (data) {
            that.$$.closeLoading();
            if (data.success) {
              let {orderToken, eventLogToken} = data.datas;

              that.orderToken = orderToken;
              that.eventLogToken = eventLogToken;

              that.$router.push({path: '/domesticTradeCredit/productDetail', query: {
                  beShareToken: that.beShareToken,
                  eventLogToken: that.eventLogToken,
                }});

              // 产品屏幕录制
              that.recording();
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });
      },
      // 产品屏幕录制
      recording(){
        let that = this;
        let eventLogToken = decodeURIComponent(encodeURIComponent(that.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
        if (that.$$.isValidObj(eventLogToken)) {
          that.screenRecBase.startLoad();
          that.eventLogToken = eventLogToken;
        }
      },
    },
    mounted() {
      let that = this;
      const {beShareToken} = that.$route.query;
      let shareToken = decodeURIComponent(encodeURIComponent(beShareToken).replace(new RegExp("%20","gm"),"%2B"));
      that.beShareToken = shareToken;

      that.findInsuranceInfoDetail();
    },
  }
</script>

<style scoped>
  .wrapper{
    padding: 20px 30%;
  }

  .submitBtn {
    width: 100%;
    height: 45px;
    line-height: 45px;
    border-radius: 8px;
    text-align: center;
    background-color: #FF7052;
    color: white;
  }

  a {
    display: inline;
    width: auto;
    color: #0075ff;
  }
  /* 自定义弹窗 */
  .customPopover{
    /*display: none;*/
  }
  .customPopover .shadow{
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0,0,0,.6);
  }
  .customPopover .dialog{
    margin: 0 auto;
    max-width: 420px;
    position: fixed;
    z-index: 5000;
    top: 50%;
    left: 20px;
    right: 20px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    text-align: center;
    border-radius: 15px;
    overflow: hidden;
    background-color: #FFFFFF;
  }
  .customPopover .dialogBd{
    width: 100%;
    background: linear-gradient(0deg, #FFF9F8 0%, #FFE3DD 100%);
    line-height: 30px;
    padding: 25px 0 15px;
  }
  .customPopover .warmPrompt{
    font-size: 18px;
    font-weight: bold;
    color: #FA6E50;
    line-height: 35px;
  }
  .customPopover .dialogTitle{
    color: #333333;
    font-size: 15px;
    font-weight: bold;
  }

  .customPopover .dialogContent{
    padding: 0 16px 15px;
    color: #666666;
    font-size: 15px;
    text-align: left;
  }

  .customPopover .insureTime{
    color: #FA6E50;
    background-color: #fff0ee;
    text-align: center;
    margin: 0 auto;
    padding: 10px 0;
  }
  .customPopover .startDate,
  .customPopover .endDate{
    color: #666666;
    line-height: 30px;
  }

  .customPopover .dialogBtn{
    padding: 20px 16px;
  }
  .customPopover .dialogBtn a{
    display: inline-block;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 400;
  }
  .customPopover .dialogBtn .onCancelLabel{
    width: calc(50% - 11px);
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    color: #333333;
    padding: 10px 0;
    margin-right: 10px;
  }
  .customPopover .dialogBtn .onOkLabel{
    width: calc(50% - 10px);
    padding: 10px 0;
    background-color: #fa6e50;
    color: #FFFFFF;
  }
  .customPopover .dialogBtn .okLabel{
    width: 100%;
    padding: 10px 0;
    background-color: #fa6e50;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/domesticTradeCredit/productDetail.vue